const loadedModules = new Map();

const hydrate = (element) => {
  const specifier = element.dataset.themeModule;
  if (!specifier || element.dataset.themeHydrated === 'true') return;
  element.dataset.themeHydrated = 'true';
  if (!loadedModules.has(specifier)) loadedModules.set(specifier, import(specifier));
  loadedModules.get(specifier).catch((error) => {
    element.dataset.themeHydrated = 'false';
    console.error(`Unable to hydrate ${specifier}`, error);
  });
};

const observe = (root = document) => {
  const elements = [
    ...(root.matches?.('[data-theme-module]') ? [root] : []),
    ...(root.querySelectorAll?.('[data-theme-module]') || []),
  ];
  elements.forEach((element) => {
    if (window.Shopify?.designMode) {
      hydrate(element);
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      if (!entries[0].isIntersecting) return;
      observer.disconnect();
      hydrate(element);
    }, { rootMargin: '600px 0px' });
    observer.observe(element);
  });
};

observe();
document.addEventListener('shopify:section:load', (event) => observe(event.target));
